<div class="flex flex-col gap-4 w-full">

  <!-- Cabeçalho -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 px-6 py-4">
    <div class="flex items-center justify-between flex-wrap gap-3">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center flex-shrink-0">
          <i class="pi pi-history text-xl text-[#E41B2E]"></i>
        </div>
        <div>
          <h1 class="text-xl font-bold text-gray-800 dark:text-white leading-tight">Histórico</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Notificações finalizadas com a linha do tempo de Status e Fase. Filtre por uma data
            para ver qual era o Status e a Fase de cada notificação naquele dia.
          </p>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-[10px] font-semibold uppercase tracking-widest text-gray-400">TAP</span>
        <span class="text-[10px] font-semibold uppercase tracking-widest text-gray-400">·</span>
        <span class="text-[10px] font-semibold uppercase tracking-widest text-gray-400">Anuladas</span>
        <span class="text-[10px] font-semibold uppercase tracking-widest text-gray-400">·</span>
        <span class="text-[10px] font-semibold uppercase tracking-widest text-gray-400">Canceladas</span>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div [formGroup]="filterForm"
       class="quick-filters bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800
              px-3 py-3 flex flex-wrap items-end gap-3">
    <div class="flex flex-col gap-0.5 flex-1 min-w-[200px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Período</span>
      <p-date-picker appendTo="body" formControlName="periodo" size="small"
                     dateFormat="dd/mm/yy" placeholder="Data inicial — Data final"
                     selectionMode="range" [readonlyInput]="true"
                     [showIcon]="true" [showClear]="true" styleClass="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[150px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Status (linha do tempo)</span>
      <p-multi-select formControlName="statusLinhaTempo" size="small"
                      [options]="statusOptions" optionLabel="nome" optionValue="nome"
                      placeholder="Todos" appendTo="body" [showClear]="true"
                      [maxSelectedLabels]="2" styleClass="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[150px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Fase (linha do tempo)</span>
      <p-multi-select formControlName="faseLinhaTempo" size="small"
                      [options]="faseOptions" optionLabel="nome" optionValue="nome"
                      placeholder="Todas" appendTo="body" [showClear]="true"
                      [maxSelectedLabels]="2" styleClass="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[150px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Concessionária</span>
      <p-multi-select formControlName="concessionaria" size="small"
                      [options]="concessionariaOptions" optionLabel="nome" optionValue="nome"
                      placeholder="Todas" appendTo="body" [showClear]="true"
                      [maxSelectedLabels]="1" styleClass="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[150px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Superintendência</span>
      <p-multi-select formControlName="superintendencia" size="small"
                      [options]="superintendenciaOptions" optionLabel="nome" optionValue="nome"
                      placeholder="Todas" appendTo="body" [showClear]="true"
                      [maxSelectedLabels]="1" styleClass="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Nº NOT</span>
      <input pInputText size="small" formControlName="numeroNotificacao" placeholder="Nº NOT" class="w-full"/>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
      <span class="text-[9px] text-gray-400 uppercase tracking-wide">Nº SEI</span>
      <input pInputText size="small" formControlName="processo" placeholder="Nº SEI" class="w-full"/>
    </div>
    <p-button size="small" label="Limpar Filtros" styleClass="btn-outlined" (click)="limparFiltros()" [disabled]="!temFiltros">
      <app-icon-bold-broom/>
    </p-button>
  </div>

  <!-- Linha de controles: Exibição de Colunas + Exibir Paginação (padrão Controle de Notificações) -->
  <div class="flex flex-wrap items-center gap-3">
    <p-button (click)="onOpenColumnsConfig()" size="small" styleClass="btn-outlined"
              [label]="'Exibição de Colunas (' + visibleColumnsCount + ')'">
      <i class="pi pi-table text-xs"></i>
    </p-button>
    <div class="flex items-center gap-2">
      <p-checkbox [(ngModel)]="showPagination" (onChange)="onChangeShowPagination()" [binary]="true"/>
      <span class="text-xs text-gray-500 dark:text-gray-400">Exibir Paginação</span>
    </div>
  </div>

  <!-- Tabela -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 flex flex-col overflow-hidden">

    <div class="flex items-center justify-between gap-2 px-4 py-2.5 border-b border-gray-100 dark:border-zinc-800">
      <span class="text-xs text-gray-500 dark:text-gray-400">
        @if (loading) { Carregando… }
        @else { <strong class="text-gray-700 dark:text-gray-200">{{ totalRecords }}</strong> notificação(ões) }
      </span>
      @if (temFiltros) {
        <span class="text-[11px] text-[#E41B2E] flex items-center gap-1">
          <i class="pi pi-filter-fill text-[10px]"></i> filtros aplicados
        </span>
      }
    </div>

    <div translate="no" class="notranslate overflow-x-auto">
      <p-table
        [value]="dados"
        dataKey="id"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [loading]="loading"
        [paginator]="showPagination"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="rowsOptions"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} de {totalRecords} registros"
        [paginatorStyleClass]="'table-paginator'"
        [paginatorDropdownAppendTo]="'body'"
        [rowHover]="true"
        [sortMode]="'single'"
        [scrollable]="!showPagination"
        [scrollHeight]="showPagination ? undefined : '65vh'"
        class="flat-table vd-table"
        [tableStyle]="{'min-width': '62rem'}"
        styleClass="p-datatable-sm">

        <ng-template #header>
          <tr>
            @if (isColumnVisible('numeroNotificacao')) {
              <th pSortableColumn="numeroNotificacao" style="min-width:9rem">
                <div class="flex items-center justify-center gap-1.5">
                  <button type="button" (click)="$event.stopPropagation(); toggleColumnFilters()"
                          [title]="showColumnFilters ? 'Ocultar filtros das colunas' : 'Mostrar filtros das colunas'"
                          class="flex items-center justify-center w-4 h-4 rounded hover:bg-white/20 transition-colors">
                    <i class="pi text-[10px]" [ngClass]="showColumnFilters ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                  </button>
                  Nº NOT <p-sortIcon field="numeroNotificacao"/>
                </div>
              </th>
            }
            @if (isColumnVisible('processo')) {
              <th pSortableColumn="processo" style="min-width:11rem">
                <div class="flex items-center justify-center gap-1">Nº SEI <p-sortIcon field="processo"/></div>
              </th>
            }
            @if (isColumnVisible('concessionaria')) {
              <th style="min-width:12rem"><div class="flex items-center justify-center">Concessionária</div></th>
            }
            @if (isColumnVisible('superintendencia')) {
              <th style="min-width:8rem"><div class="flex items-center justify-center">Superint.</div></th>
            }
            @if (isColumnVisible('dataNotificacao')) {
              <th pSortableColumn="dataNotificacao" style="min-width:8rem">
                <div class="flex items-center justify-center gap-1">Data NOT <p-sortIcon field="dataNotificacao"/></div>
              </th>
            }
            @if (isColumnVisible('statusLinhaTempo')) {
              <th style="min-width:16rem" [attr.colspan]="2">
                <div class="flex items-center justify-center">Linha do tempo — Status</div>
              </th>
            }
            @if (isColumnVisible('faseLinhaTempo')) {
              <th style="min-width:16rem" [attr.colspan]="2">
                <div class="flex items-center justify-center">Linha do tempo — Fase</div>
              </th>
            }
          </tr>
          <tr [formGroup]="filterForm" [class.hidden]="!showColumnFilters">
            @if (isColumnVisible('numeroNotificacao')) {
              <th class="p-1"><input pInputText size="small" formControlName="numeroNotificacao" placeholder="Pesquise" fluid class="w-full"/></th>
            }
            @if (isColumnVisible('processo')) {
              <th class="p-1"><input pInputText size="small" formControlName="processo" placeholder="Pesquise" fluid class="w-full"/></th>
            }
            @if (isColumnVisible('concessionaria')) {
              <th class="p-1">
                <p-multi-select formControlName="concessionaria" size="small" [options]="concessionariaOptions"
                                optionLabel="nome" optionValue="nome" placeholder="Selecione" appendTo="body"
                                [maxSelectedLabels]="1" [showClear]="true" fluid/>
              </th>
            }
            @if (isColumnVisible('superintendencia')) {
              <th class="p-1">
                <p-multi-select formControlName="superintendencia" size="small" [options]="superintendenciaOptions"
                                optionLabel="nome" optionValue="nome" placeholder="Selecione" appendTo="body"
                                [maxSelectedLabels]="1" [showClear]="true" fluid/>
              </th>
            }
            @if (isColumnVisible('dataNotificacao')) {
              <th class="p-1">
                <p-date-picker appendTo="body" formControlName="periodo" size="small"
                               dateFormat="dd/mm/yy" placeholder="DD/MM/AAAA" selectionMode="range"
                               [readonlyInput]="true" [showIcon]="true" [showClear]="true" fluid/>
              </th>
            }
            @if (isColumnVisible('statusLinhaTempo')) {
              <th class="p-1" [attr.colspan]="2">
                <p-multi-select formControlName="statusLinhaTempo" size="small" [options]="statusOptions"
                                optionLabel="nome" optionValue="nome" placeholder="Selecione" appendTo="body"
                                [maxSelectedLabels]="1" [showClear]="true" fluid/>
              </th>
            }
            @if (isColumnVisible('faseLinhaTempo')) {
              <th class="p-1" [attr.colspan]="2">
                <p-multi-select formControlName="faseLinhaTempo" size="small" [options]="faseOptions"
                                optionLabel="nome" optionValue="nome" placeholder="Selecione" appendTo="body"
                                [maxSelectedLabels]="1" [showClear]="true" fluid/>
              </th>
            }
          </tr>
        </ng-template>

        <ng-template #body let-item>
          @let statusVis = linhaVisivel(item.statusLinhaTempo);
          @let faseVis = linhaVisivel(item.faseLinhaTempo);
          <tr class="align-top">
            @if (isColumnVisible('numeroNotificacao')) {
              <td class="whitespace-nowrap font-semibold text-gray-800 dark:text-gray-100 tabular-nums">{{ item.numeroNotificacao || '—' }}</td>
            }
            @if (isColumnVisible('processo')) {
              <td class="whitespace-nowrap tabular-nums text-gray-600 dark:text-gray-300"><app-abrir-sei [texto]="item.processo"/></td>
            }
            @if (isColumnVisible('concessionaria')) {
              <td class="text-gray-600 dark:text-gray-300">{{ item.concessionaria || '—' }}</td>
            }
            @if (isColumnVisible('superintendencia')) {
              <td class="text-gray-600 dark:text-gray-300 text-center">{{ item.superintendencia || '—' }}</td>
            }
            @if (isColumnVisible('dataNotificacao')) {
              <td class="whitespace-nowrap text-center tabular-nums text-gray-600 dark:text-gray-300">
                {{ (item.dataNotificacao | date:'dd/MM/yyyy') || '—' }}
              </td>
            }

            <!-- Status: datas | valores -->
            @if (isColumnVisible('statusLinhaTempo')) {
              <td class="vd-timeline-dates">
                <div class="vd-stack">
                  @for (e of statusVis; track $index) {
                    <span class="vd-date">{{ e.data | date:'dd/MM/yyyy' }}</span>
                  }
                </div>
              </td>
              <td class="vd-timeline-vals">
                <div class="vd-stack">
                  @for (e of statusVis; track $index; let last = $last) {
                    <span class="vd-pill" [ngClass]="statusPillClass(e.valor)" [class.vd-atual]="last && !temPeriodo()">
                      {{ e.valor || '—' }}@if (last && !temPeriodo() && statusVis.length > 1) {<i class="vd-dot"></i>}
                    </span>
                  }
                </div>
              </td>
            }

            <!-- Fase: datas | valores -->
            @if (isColumnVisible('faseLinhaTempo')) {
              <td class="vd-timeline-dates">
                <div class="vd-stack">
                  @for (e of faseVis; track $index) {
                    <span class="vd-date">{{ e.data | date:'dd/MM/yyyy' }}</span>
                  }
                </div>
              </td>
              <td class="vd-timeline-vals">
                <div class="vd-stack">
                  @for (e of faseVis; track $index; let last = $last) {
                    <span class="vd-pill vd-pill-fase" [class.vd-atual]="last && !temPeriodo()">
                      {{ e.valor || '—' }}@if (last && !temPeriodo() && faseVis.length > 1) {<i class="vd-dot"></i>}
                    </span>
                  }
                </div>
              </td>
            }
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          @if (!loading) {
            <tr>
              <td [attr.colspan]="totalPhysicalColumns">
                <div class="flex flex-col items-center gap-2 py-12 text-gray-400 dark:text-zinc-500">
                  <i class="pi pi-inbox text-4xl"></i>
                  <p class="text-sm font-medium">Nenhuma notificação encontrada</p>
                  @if (temFiltros) {
                    <button type="button" class="text-xs text-[#E41B2E] hover:underline" (click)="limparFiltros()">
                      limpar filtros
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        </ng-template>

        <ng-template #loadingbody>
          @for (i of [1,2,3,4,5,6]; track $index) {
            <tr>
              @for (c of skeletonColumns; track $index) {
                <td><p-skeleton height="1.4rem"/></td>
              }
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  </div>

</div>

<!-- Dialog: Exibição de Colunas -->
<p-dialog [(visible)]="showColumnsDialog"
          [closable]="true"
          [modal]="true"
          [style]="{width: '420px', maxHeight: '90vh'}">
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="pi pi-table text-[#E41B2E]"></i>
      <span class="header-title-dialog">Exibição de Colunas</span>
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between">
      <span class="text-sm text-gray-500 dark:text-gray-400">
        {{ configColumns.length }} colunas · marque para exibir
      </span>
      <div class="flex gap-2">
        <button (click)="showAllColumns()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Todas
        </button>
        <button (click)="hideAllColumns()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Nenhuma
        </button>
        <button (click)="resetColumnsConfig()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Padrão
        </button>
      </div>
    </div>

    <div class="flex flex-col gap-1 max-h-[360px] overflow-y-auto pr-1">
      @for (item of configColumns; track item.field) {
        <div class="flex items-center gap-3 px-3 py-2 rounded-lg border transition-colors
                    bg-white dark:bg-black border-gray-200 dark:border-red-950
                    hover:border-gray-300 dark:hover:border-red-800"
             [class.opacity-50]="!item.visible">
          <p-checkbox [(ngModel)]="item.visible" [binary]="true"/>
          <span class="text-sm flex-1 truncate"
                [ngClass]="item.visible ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400'">
            {{ item.label }}
          </span>
        </div>
      }
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Cancelar" styleClass="btn-transparent" (click)="showColumnsDialog = false"/>
      <p-button label="Aplicar" styleClass="btn-red" (click)="applyColumnsConfig()">
        <i class="pi pi-check"></i>
      </p-button>
    </div>
  </ng-template>
</p-dialog>
